'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _aphrodite = require('aphrodite');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Select Country of Nationality
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - user's country used to determine add card and add address formats
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var STYLES = _aphrodite.StyleSheet.create({
	dropdown: {
		padding: 0,
		textIndent: 10,
		WebkitAppearance: 'none',
		MozAppearance: 'none',
		appearance: 'none',
		'@-moz-document url-prefix()': {
			textIndent: 2.5
		},
		'::-ms-expand': { display: 'none' }
	},

	arrow: {
		position: 'absolute',
		right: 10,
		top: '50%',
		cursor: 'default',
		pointerEvents: 'none'
	}
});

var CountrySelection = function (_React$Component) {
	_inherits(CountrySelection, _React$Component);

	function CountrySelection() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, CountrySelection);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CountrySelection.__proto__ || Object.getPrototypeOf(CountrySelection)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
			selectedCountry: _this.props.defaultValue || _this.props.supportedCountries[0].countryCode
		}, _this.handleChangeCountry = function (event) {
			var selectedCountry = event.target.value;
			_this.setState({ selectedCountry: selectedCountry });
			_this.props.changeCountry(selectedCountry);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	/**
 * Set initial state to the first country in the list
 */


	_createClass(CountrySelection, [{
		key: 'componentDidMount',


		/**
  * Select the first country in the list
  */
		value: function componentDidMount() {
			this.props.changeCountry(this.state.selectedCountry);
		}

		/**
  * Handle changing the selected country
  * - set the state
  * - call parent's changeCountry() with the selected country
  */

	}, {
		key: 'render',
		value: function render() {

			// don't render anything if we don't get the correctly formatted list of countries
			if (!this.props.supportedCountries[0].countryCode) {
				return null;
			}

			return _react2.default.createElement(
				'div',
				{ style: { position: 'relative' } },
				_react2.default.createElement(
					'select',
					{ id: 'countrySelection',
						className: 'vx_form-control ' + (0, _aphrodite.css)(STYLES.dropdown),
						value: this.state.selectedCountry,
						onChange: this.handleChangeCountry },
					this.props.supportedCountries.map(function (_ref2) {
						var countryCode = _ref2.countryCode,
						    countryName = _ref2.countryName;
						return _react2.default.createElement(
							'option',
							{ key: countryCode, value: countryCode },
							countryName
						);
					})
				),
				_react2.default.createElement('label', { htmlFor: 'countrySelection', className: 'icon icon-arrow-down-small ' + (0, _aphrodite.css)(STYLES.arrow) })
			);
		}
	}]);

	return CountrySelection;
}(_react2.default.Component);

CountrySelection.propTypes = {
	supportedCountries: function supportedCountries(props, propName, componentName) {
		var supportedCountries = props[propName];

		// if we don't get the array of states we're expecting from Griffin, return an error
		if (!Array.isArray(supportedCountries) || supportedCountries.length && !supportedCountries[0].countryCode) {
			return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`. Please supply the array you get back from griffin.metadata.allSupportedCountries(), but map each supported country to an object: `{ countryCode, countryName }.`');
		}
		return null;
	},
	defaultValue: _propTypes2.default.string,
	changeCountry: _propTypes2.default.func.isRequired
};
CountrySelection.defaultProps = {
	supportedCountries: [],
	changeCountry: function changeCountry() {}
};
exports.default = CountrySelection;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/guest-payment/dist/components/CountrySelection.js
// module id = 696
// module chunks = 5